// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__-rQbu","approved":"Status_approved__2TNgg","rejected":"Status_rejected__88aIj","expired":"Status_expired__1phgg","label":"Status_label__36l8m"};